import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('intializeEditorViewStateMessage', function intializeEditorViewState() {
    var editorViewState = getStore().currentState.editorViewStateMessage;
    var initialEditorViewState = getStore().initialState.editorViewStateMessage;
    editorViewState.content = initialEditorViewState.content;
});
//# sourceMappingURL=intializeEditorViewStateMessage.js.map